module.exports = __webpack_public_path__ + "img/map-and-contact-map-bg-01.a49a113d.png";